import { ChangeDetectorRef, inject, Injectable, OnDestroy, signal } from '@angular/core';

import { IVzSubscription, SM } from '@models/base/helper-types';
import { getRandomId } from '@models/utils/uuid';
import { finalize, Observable } from 'rxjs';
import { HttpApiError } from '@models/api/http-api-error';
import { BaseService } from './base-service';

@Injectable()
export class BaseCmp implements OnDestroy {

    protected readonly _S: SM<IVzSubscription> = {};
    protected __DESTROING = signal<boolean>(false);

    protected readonly __B      = inject(BaseService);
    protected readonly __cdr    = inject(ChangeDetectorRef, { optional: true });
    protected readonly __CID    = getRandomId(8);

    readonly _error     = signal<HttpApiError | undefined>(undefined);
    readonly _loading   = signal<boolean>(true);
    readonly _working   = signal<boolean>(false);

    ngOnDestroy(): void {
        this.__DESTROING.set(true);
        this.__Uall();
    }

    protected __Uexcept(exceptKeys?: string[]): void {
        this.__U(exceptKeys ? Object.keys(this._S).filter(id => !exceptKeys.includes(id)) : Object.keys(this._S));
    }

    protected __Uall(): void {
        this.__U(Object.keys(this._S));
    }

    protected __U(unsubscribeKeys: string[]): void {
        for (const id of unsubscribeKeys) {
            if (this._S[id] && !this._S[id].closed) {
                // console.log('unsubscribe:', id);
                this._S[id].unsubscribe();
                delete this._S[id];
            }
        }
    }

    _Loading<T>(obs: Observable<T>, opts?: { cb?: () => void }): Observable<T> {
        this._loading.set(true);
        this._Changed();
        return obs.pipe(finalize(() => {
            this._loading.set(false);
            this._Changed();
            if (opts?.cb) {
                opts?.cb();
            }
        }));
    }

    _Working<T>(obs: Observable<T>, opts?: { cb?: () => void }): Observable<T> {
        this._working.set(true);
        this._Changed();
        return obs.pipe(finalize(() => {
            this._working.set(false);
            this._Changed();
            if (opts?.cb) {
                opts?.cb();
            }
        }));
    }

    _Changed(): void {
        if (this.__cdr) {
            try {
                this.__cdr.detectChanges();
            }
            catch {
                this.__cdr.markForCheck();
            }
        }
    }

    _Error(err: HttpApiError | undefined): void {
        this._error.set(err);
        this._Changed();
    }

}
